import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@services/api";

const STORAGE_KEY = "ww_admin_auth";

// Default value so useAuth() never returns null
const AuthContext = createContext({
  user: null,
  token: null,
  permissions: [],
  loading: false,
  login: async () => ({ ok: false, error: "Auth not initialized" }),
  logout: () => {},
  hasPermission: () => true,
  isAuthenticated: false
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        setUser(parsed.user || null);
        setPermissions(parsed.permissions || []);
        setToken(parsed.token || null);

        if (parsed.token) {
          api.defaults.headers.common.Authorization = `Bearer ${parsed.token}`;
        }
      }
    } catch (e) {
      console.error("Failed to parse auth from storage", e);
      localStorage.removeItem(STORAGE_KEY);
    }
  }, []);

    function hasPermission(permission) {
        if (!permission) return true;

        const access = permissions?.access;
        if (!Array.isArray(access)) return false;

        return access.includes(permission);
    }
  async function login(login, password) {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { login, password });

      const authPayload = {
        token: data.token,
        user: data.user,
        permissions: data.permissions || []
      };

      setToken(authPayload.token);
      setUser(authPayload.user);
      setPermissions(authPayload.permissions);

      localStorage.setItem(STORAGE_KEY, JSON.stringify(authPayload));
      api.defaults.headers.common.Authorization = `Bearer ${authPayload.token}`;

      setLoading(false);
      return { ok: true };
    } catch (e) {
      setLoading(false);
      return {
        ok: false,
        error:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          "Login failed"
      };
    }
  }

  function logout() {
    console.log(
      "Logout: storage before clear:",
      localStorage.getItem(STORAGE_KEY)
    );

    localStorage.removeItem(STORAGE_KEY);
    delete api.defaults.headers.common.Authorization;

    setUser(null);
    setToken(null);
    setPermissions([]);

    console.log(
      "Logout: storage after clear:",
      localStorage.getItem(STORAGE_KEY)
    );
  }

  const value = {
    user,
    token,
    permissions,
    loading,
    login,
    logout,
    hasPermission,
    isAuthenticated: !!token
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}

